module.exports = __webpack_public_path__ + "img/13.4ba6d5c4.png";